export default function ProgressBar({ value, max = 100, testid }) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className="moe-progress-track" data-testid={testid}>
      <div className="moe-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
